import {
  IMusselLineDetail,
  IOysterLineDetail,
  ISeaweedLineDetail,
} from '../../entities/farms.entities';
import { ICycleResource } from '../../entities/growing.entities';
import FlupsyMusselLineDesktop from './FlupsyMusselLineDesktop';
import MusselLineDesktop from './MusselLineDesktop';
import OysterLineDesktop from './OysterLineDesktop';
import SeaweedLineDesktop from './SeaweedLineDesktop';

interface Props {
  lineData: IMusselLineDetail | IOysterLineDetail | ISeaweedLineDetail;
  loadLine: () => void;
  cyclePart: ICycleResource | null;
  isPrevEnabled: boolean;
  isNextEnabled: boolean;
  onClickPrevGroup: () => void;
  onClickNextGroup: () => void;
  showEditLineModal: () => void;
  onSeedingClick: () => void;
  onAssessmentClick: () => void;
  onCatchSpatClick: () => void;
  onHarvestClick: () => void;
  onReturnClick: () => void;
  onMaintenanceClick: () => void;
  onFloatingManageClick: () => void;
  onExtraSeedClick: () => void;
  checkedHistoryView: number;
  onHistoryViewClick: () => void;
  onDeleteClick: () => void;
  onMetaEditClick: () => void;
  onWasteClick: () => void;
}

const LineTemplateDesktop = ({
  lineData,
  loadLine,
  cyclePart,
  isPrevEnabled,
  isNextEnabled,
  onClickPrevGroup,
  onClickNextGroup,
  showEditLineModal,
  onSeedingClick,
  onAssessmentClick,
  onCatchSpatClick,
  onHarvestClick,
  onReturnClick,
  onMaintenanceClick,
  onFloatingManageClick,
  onExtraSeedClick,
  checkedHistoryView,
  onHistoryViewClick,
  onDeleteClick,
  onMetaEditClick,
  onWasteClick,
}: Props) => (
  <>
    {lineData.farm_is_flupsy ? (
      <>
        {lineData.crop_type === 'MUSSEL' && (
          <FlupsyMusselLineDesktop
            lineData={lineData as IMusselLineDetail}
            loadLine={loadLine}
            cyclePart={cyclePart}
            isPrevEnabled={isPrevEnabled}
            isNextEnabled={isNextEnabled}
            onClickPrevGroup={onClickPrevGroup}
            onClickNextGroup={onClickNextGroup}
            showEditLineModal={showEditLineModal}
            onSeedingClick={onSeedingClick}
            onAssessmentClick={onAssessmentClick}
            onCatchSpatClick={onCatchSpatClick}
            onHarvestClick={onHarvestClick}
            onMaintenanceClick={onMaintenanceClick}
            onFloatingManageClick={onFloatingManageClick}
            onExtraSeedClick={onExtraSeedClick}
            checkedHistoryView={checkedHistoryView}
            onHistoryViewClick={onHistoryViewClick}
            onMetaEditClick={onMetaEditClick}
            onWasteClick={onWasteClick}
          />
        )}
        {lineData.crop_type === 'OYSTER' && (
          <OysterLineDesktop
            lineData={lineData as IOysterLineDetail}
            cyclePart={cyclePart}
            isPrevEnabled={isPrevEnabled}
            isNextEnabled={isNextEnabled}
            onClickPrevGroup={onClickPrevGroup}
            onClickNextGroup={onClickNextGroup}
            showEditLineModal={showEditLineModal}
            onSeedingClick={onSeedingClick}
            onAssessmentClick={onAssessmentClick}
            onCatchSpatClick={onCatchSpatClick}
            onHarvestClick={onHarvestClick}
            onReturnClick={onReturnClick}
            onMaintenanceClick={onMaintenanceClick}
            onExtraSeedClick={onExtraSeedClick}
            onFloatingManageClick={onFloatingManageClick}
            checkedHistoryView={checkedHistoryView}
            onHistoryViewClick={onHistoryViewClick}
            onMetaEditClick={onMetaEditClick}
            loadLine={loadLine}
          />
        )}
      </>
    ) : (
      <>
        {lineData.crop_type === 'MUSSEL' ? (
          <MusselLineDesktop
            lineData={lineData as IMusselLineDetail}
            loadLine={loadLine}
            cyclePart={cyclePart}
            isPrevEnabled={isPrevEnabled}
            isNextEnabled={isNextEnabled}
            onClickPrevGroup={onClickPrevGroup}
            onClickNextGroup={onClickNextGroup}
            showEditLineModal={showEditLineModal}
            onDeleteClick={onDeleteClick}
            onSeedingClick={onSeedingClick}
            onAssessmentClick={onAssessmentClick}
            onCatchSpatClick={onCatchSpatClick}
            onHarvestClick={onHarvestClick}
            onReturnClick={onReturnClick}
            onMaintenanceClick={onMaintenanceClick}
            onFloatingManageClick={onFloatingManageClick}
            onExtraSeedClick={onExtraSeedClick}
            onMetaEditClick={onMetaEditClick}
            checkedHistoryView={checkedHistoryView}
            onHistoryViewClick={onHistoryViewClick}
            onWasteClick={onWasteClick}
          />
        ) : lineData.crop_type === 'OYSTER' ? (
          <OysterLineDesktop
            lineData={lineData as IOysterLineDetail}
            cyclePart={cyclePart}
            isPrevEnabled={isPrevEnabled}
            isNextEnabled={isNextEnabled}
            onClickPrevGroup={onClickPrevGroup}
            onClickNextGroup={onClickNextGroup}
            showEditLineModal={showEditLineModal}
            onSeedingClick={onSeedingClick}
            onAssessmentClick={onAssessmentClick}
            onCatchSpatClick={onCatchSpatClick}
            onHarvestClick={onHarvestClick}
            onReturnClick={onReturnClick}
            onMaintenanceClick={onMaintenanceClick}
            onExtraSeedClick={onExtraSeedClick}
            onFloatingManageClick={onFloatingManageClick}
            onMetaEditClick={onMetaEditClick}
            checkedHistoryView={checkedHistoryView}
            onHistoryViewClick={onHistoryViewClick}
            loadLine={loadLine}
          />
        ) : (
          <SeaweedLineDesktop
            lineData={lineData as ISeaweedLineDetail}
            cyclePart={cyclePart}
            isPrevEnabled={isPrevEnabled}
            isNextEnabled={isNextEnabled}
            onClickPrevGroup={onClickPrevGroup}
            onClickNextGroup={onClickNextGroup}
            showEditLineModal={showEditLineModal}
            onSeedingClick={onSeedingClick}
            onAssessmentClick={onAssessmentClick}
            onCatchSpatClick={onCatchSpatClick}
            onHarvestClick={onHarvestClick}
            onReturnClick={onReturnClick}
            onMaintenanceClick={onMaintenanceClick}
            onExtraSeedClick={onExtraSeedClick}
            onMetaEditClick={onMetaEditClick}
            onFloatingManageClick={onFloatingManageClick}
            checkedHistoryView={checkedHistoryView}
            onHistoryViewClick={onHistoryViewClick}
            loadLine={loadLine}
          />
        )}
      </>
    )}
  </>
);

export default LineTemplateDesktop;
